export default __webpack_public_path__ + "static/media/user-x.bf2b696f.svg";